/** @jsxImportSource react */

export function WelcomeView() {
  return (
    <div
      className="flex h-full flex-col items-center justify-center p-6"
      style={{
        background: "linear-gradient(to bottom right, #F4F8FB, #E5EDF3)",
      }}
    >
      <div className="max-w-2xl text-center h-full">
        {/* Logo o icono principal */}
        <div className="mb-8 text-8xl">🗳️</div>

        {/* Título principal */}
        <h1 className="mb-4 text-5xl font-bold text-slate-900">
          Dashboard Electoral 2025
        </h1>

        {/* Subtítulo */}
        <p className="mb-8 text-xl text-slate-600">
          Bienvenido al sistema de análisis y seguimiento electoral de Radio
          Urbana PLAY
        </p>

        {/* Indicador visual hacia abajo */}
        <div className="flex flex-col items-center gap-3">
          <span className="text-sm font-medium uppercase tracking-wide text-slate-400">
            Selecciona una sección
          </span>
          <svg
            className="h-8 w-8 animate-bounce text-slate-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
